import { ArrowUpOutlined, LoadingOutlined } from '@ant-design/icons';
import React from 'react';
import BCButton from '../../BCButton';
import { BCSpaceCompact } from '../../BCSpace';
import BCTextArea, { BCTextAreaRef, ITextAreaChangeEventArgs } from '../../BCTextArea';
import Styles from '../assets/styles.scss';
import { IChatInput } from '../entities/IChatInput';

const autosize = { minRows: 1, maxRows: 9 };

const ChatInput: React.FC<IChatInput> = props => {
	const [prompt, setPrompt] = React.useState('');

	React.useEffect(() => {
		inputRef.current.focus();
	}, []);

	const inputRef = React.useRef<BCTextAreaRef>();

	const onPressEnter = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
		if (!e.shiftKey) {
			e.preventDefault();
			props.onPromptSent(prompt);
			setPrompt('');
		}
	};

	const onSendButtonClicked = () => {
		props.onPromptSent(prompt);
		setPrompt('');
		inputRef.current.focus();
	};

	const onPromptChange = (args: ITextAreaChangeEventArgs) => {
		setPrompt(args.data.trim());
	};

	const getButtonIcon = () => (props.loading ? <LoadingOutlined /> : <ArrowUpOutlined />);

	return (
		<div className={Styles.input}>
			{props.children}
			<BCSpaceCompact block>
				<BCTextArea
					value={prompt}
					placeHolder={props.placeHolder}
					onPressEnter={onPressEnter}
					onChange={onPromptChange}
					ref={inputRef}
					autosize={autosize}
					rows={1}
					size="large"
					className={Styles.textarea}
					variant="filled"
					disabled={props.disabled}
				/>
				<BCButton
					icon={getButtonIcon()}
					onClick={onSendButtonClicked}
					disabled={props.disabled || (props.loading ? false : !prompt.trim())}
					className={Styles.send}
				/>
			</BCSpaceCompact>
		</div>
	);
};

export { ChatInput };
